import * as yup from 'yup'

export const bookingInfoSchema = yup.object({
  flightNumber: yup.string().max(64).optional(),
  pickupSign: yup.string().max(128).optional(),
  passengerCount: yup
    .number()
    .min(1, 'At least 1 passenger required')
    .max(20, 'Maximum 20 passengers')
    .required('Passenger count is required'),
  luggage: yup.string().max(128).optional(),
  notes: yup.string().max(500).optional(),
  bookingForSomeoneElse: yup.string().oneOf(['myself', 'someoneelse']).required(),
  guestFullName: yup.string().optional(),
  guestEmail: yup.string().email('Invalid email').optional(),
  guestPhoneNumber: yup.string().when('bookingForSomeoneElse', {
    is: 'someoneelse',
    then: schema => schema.required('Guest phone number is required').max(32),
    otherwise: schema => schema.optional(),
  }),
})

export type BookingInfoFormData = yup.InferType<typeof bookingInfoSchema>
